module.exports = __webpack_public_path__ + "assets/img/f65059332e0b5f4a3b761cf86a3c1b3f.png";